<template>
	<div class="videolist">
		<div class="breadcrumb">人员列表</div>
		<div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<div class="topinput">
				<input type="text" v-model="nickName" class="el-input__inner" placeholder="人员名称" @keyup.enter="search_mine">
			</div>
			<div class="topinput">
				<el-select v-model="roleId" placeholder="请选择所属角色" style="width:100%">
				    <el-option v-for="item in roleListData" :key="item.id" :label="item.roleName" :value="item.id">{{item.roleName}}</el-option>
			  	</el-select>
		  	</div>
			<div class="topinput" style="margin-right:15px">
				<el-select v-model="loginStatus" placeholder="请选择人员状态" style="width:100%">
				    <el-option
				      	v-for="item in options"
				      	:key="item.value"
				      	:label="item.label"
				      	:value="item.value">
				    </el-option>
			  	</el-select>
		  	</div>
		  	<el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" border header-cell-class-name="table-header" style="width: 100%">
	    	<!-- <el-table-column type="selection" width="55"></el-table-column> -->
		    <el-table-column prop="id" label="ID"></el-table-column>
		    <el-table-column prop="nickname" label="人员名称"></el-table-column>
		    <el-table-column prop="roleName" label="所属角色"></el-table-column>
		    <el-table-column prop="departmentName" label="所属部门"></el-table-column>
		    <el-table-column prop="introduction" label="人员描述"></el-table-column>
		    <el-table-column prop="nickname" label="人员状态">
		    	<template slot-scope="scope">
		    		{{scope.row.loginStatus==1?'有效':'无效'}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>
			<el-table-column label="操作" width="140" align="center">
					<template slot-scope="scope">
						<el-button v-has="'course_type_update'"
								@click="edit(scope.row)"
								type="text"
								size="small"
								icon="el-icon-s-order">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button v-has="'course_type_delete'"
								slot="reference"
								type="text"
								size="small"
								style="color:red;"
								icon="el-icon-delete">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>

		<!-- 添加角色列表弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="140px">
      			<el-form-item label="人员名称" prop="nickname">
				    <el-input v-model="ruleForm.nickname"></el-input>
				</el-form-item>
				<el-form-item label="所属角色" prop="roleId">
					<el-select v-model="ruleForm.roleId" placeholder="请选择所属角色" style="width: 80%;">
		            	<el-option v-for="item in roleListData" :key="item.id" :label="item.roleName" :value="item.id">{{item.roleName}}</el-option>
		          	</el-select>
			  	</el-form-item>

			  	<el-form-item label="所属部门" prop="departmentId">
				    <el-select v-model="ruleForm.departmentId" placeholder="请选择所属部门" style="width: 80%;">
		            	<el-option v-for="item in departmentData" :key="item.id" :label="item.department" :value="item.id">{{item.department}}</el-option>
		          	</el-select>
			  	</el-form-item>

			  	<!-- <el-form-item label="请选择教练" prop="coachId" class="selectUser" v-if="ruleForm.departmentId==6">
	          		<i class="el-icon-edit" :disabled="true"></i>
	          		<label @click="selCoachesDialog()">{{ruleForm.coachName}}</label>
	          		<el-input v-model="ruleForm.coachId" v-show="isShow"></el-input>
	        	</el-form-item> -->
				<el-form-item label="请选择教练" prop="coachId" class="selectUser" v-if="ruleForm.departmentId==6">
                    <div style="padding:4px 0 10px 0;">
                        <el-tag style="margin:6px 6px 0 0;" v-for="tag in coachesChoice" :key="tag.id" closable @close="coachesChoiceMethod(tag.id)">{{tag.coachName}}</el-tag>
                    </div> 
                    <el-popover
                        placement="right"
                        width="600"
                        trigger="click">
                        <div class="coursesList-group Scrollbars-box" style="max-height:400px;">
                            <el-checkbox-group v-model="checkCoachesList" @change="ruleForm.coachId=checkCoachesList.join(',')">
                                <el-checkbox :label="item.id" v-for="item in coachesData" :key="item.id">
                                        <img :src="item.coachAvatar" alt="">
                                        <span>{{item.coachName}}</span>
                                    </el-checkbox>
                            </el-checkbox-group>
                        </div>
                         <el-button slot="reference">选择教练</el-button>
                    </el-popover>
                    <el-input v-model="ruleForm.coachId" type="hidden"></el-input> 
	        	</el-form-item>
	        	<el-form-item label="教练or教练管理员" v-if="ruleForm.departmentId==6">
			  		{{ruleForm.coachId?'教练':'教练管理员'}}
			  	</el-form-item>
				
			  	<el-form-item label="人员描述">
				    <el-input type="textarea" v-model="ruleForm.introduction" style="width:80%" :rows="4"></el-input>
			  	</el-form-item>
				<el-form-item label="用户状态" prop="loginStatus">
				    <el-radio-group v-model="ruleForm.loginStatus">
				      	<el-radio :label="1">有效</el-radio>
				      	<el-radio :label="0">无效</el-radio>
				    </el-radio-group>
			  	</el-form-item> 
			  	<el-form-item label="手机号" prop="mobile">
				    <el-input v-model="ruleForm.mobile"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="userName">
				    <el-input v-model="ruleForm.userName"></el-input>
				</el-form-item>
				<el-form-item label="密码">
          			<el-input v-model="ruleForm.password1" type="password" placeholder="默认不显示，要更新请输入新密码" readonly onfocus="this.removeAttribute('readonly');" style="width: 80%;"></el-input>
        		</el-form-item>
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
		    </span>
    	</el-dialog>

    	<!-- 选择教练弹框 -->
	    <el-dialog title="选择教练" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose2">
	      	<el-scrollbar style="height:500px; width:100%;cursor:pointer">
	        	<template>
	          		<el-table ref="multipleTable" :data="coachesData" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange2">
		            	<el-table-column prop="id" align="center" label="ID"></el-table-column>
		            	<el-table-column prop="nickName" align="center" label="名字" show-overflow-tooltip></el-table-column>
	          		</el-table>
	        	</template>
		        <div class="block" style="padding:30px 10px; float:right">
		          	<el-pagination @current-change="handleCurrentChangePage2" :current-page="paramcoach.pageNum" :page-size="paramcoach.limit" layout="total, prev, pager, next, jumper" :total="totalPage2"></el-pagination>
		        </div>
	      	</el-scrollbar>
	    </el-dialog>
	</div>
</template>
<script>
import md5 from "js-md5";
export default {
  	mounted() {
  		this.init(); 
  		this.roleList();	
  	},
  	data() {
  		var mobilereg = (rule, value, callback) => {
  			var reg = /^[1][1,2,3,4,5,7,8,9][0-9]{9}$/;
	        if (value && !value.match(reg)) {
	            callback(new Error('请输入正确的手机号格式'));
	        }else {
		        callback();
		    }
      	};
    	return {
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
			checkCoachesList:[],
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tableData3: [],
	      	dialogVisible: false,
	      	ruleForm: {
	      		coachName: "点击选择",
	      		coachId:'',
	      		coachStatus:'',
				userName:''
      		},
      		rules:{
      			nickname: [
		            { required: true, message: '请输入人员名称', trigger: 'blur' }
		        ],
		        roleId:[
		            { required: true, message: '请选择所属角色', trigger: 'change' }
		        ],
		        departmentId:[
		            { required: true, message: '请选择所属部门', trigger: 'change' }
		        ],
		        loginStatus: [
		            { required: true, message: '请选择用户状态', trigger: 'change' }
		        ],
		        mobile:[
		        	{ validator: mobilereg, trigger: 'blur' }
		        ]
      		},
      		tableData2:[
      			{name:'检测人员',id:1},
      			{name:'检查员',id:2}
      		],
      		nickName:'',
      		roleId:'',
      		loginStatus:'',
      		options: [
      			{value: '0',label: '不限'}, 
      			{value: '2',label: '有效'}, 
      			{value: '1',label: '无效'}, 
      		],
      		roleListData:[],
      		departmentData:[],
      		currentRow:'',
      		multipleSelection: [],
      		paramcoach:{
    			pageNum: 1,
        		limit: 10
    		},
    		coachesData:[],
    		totalPage2:10,
    		isShow: false,
    		dialogVisible2:false
	    };
  	},
	computed: {
        coachesChoice:function(){
            let arr=[];
            this.coachesData.forEach(item=>{
                this.checkCoachesList.forEach(val=>{
                    if(item.id == val){
                        arr.push(item)
                    }
                })
            })
            return arr;
        },
    },
  	methods:{
		coachesChoiceMethod(coachesId){
            for(let i=0;i<this.checkCoachesList.length;i++){
                if(this.checkCoachesList[i] == coachesId){
                    this.checkCoachesList.splice(i,1)
                }
            }
        },
  		coach(val){
  			console.log(val)
  		},
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		nickName:this.nickName,
        		roleId:this.roleId,
        		loginStatus:this.loginStatus
      		};
      		this.$get("/authorityManagement/getManageUserList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
  		},
  		handleSelectionChange(val) {
	        this.multipleSelection = val;
	        console.log(this.multipleSelection)
	    },
  		handleCurrentChange(val) {
	      	if (val) {
	        	this.currentRow = val;
	      	}
	    },
  		roleList(){//所属角色
  			var params = {
        		type:1
      		};
      		this.$get("/authorityManagement/getManageRoleList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.roleListData=res.data.list
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		getManageDepartment(){//所属部门
  			this.$get("/authorityManagement/getManageDepartment")
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.departmentData=res.data
          		} else {
            		this.$message.error(res.message);
          		}
        	})
  		},
  		//当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	      		this.ruleForm={
	      		}
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.currentRow='';
	      	this.dialogVisible = true;
	      	this.getManageDepartment();
			this.selCoachesDialog();
  		},
	    edit(data){
			this.currentRow=data;
			this.ruleForm=this.currentRow;
			this.getManageDepartment();
			this.selCoachesDialog();
			let coachesList=this.$_.isNumber(data.coachId)?[data.coachId]:[];
			this.checkCoachesList=coachesList.map(item=>Number(item));
			this.dialogVisible = true;
	    },
	    del(id){
	    	this.$post("/authorityManagement/delManageUser",{ids:[id]})
				.then(function(res) {
					console.log(res);
					if (res.code == 0) {
						this.$message.success('操作成功');
						this.currentRow='';
						this.pageNum = 1;
						this.init();
						this.dialogVisible = false;
					} else {
						this.$message.success(res.message);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
	    },
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
			        
		      	}
	      	}
	      	done();
	    },
	    search_mine(){
	    	this.init();
	    },
	    selCoachesDialog(){
	    	this.$get('/coaches', {pageNum:1,limit:1000})
                .then(res => {
                    if (res.code == 0) {
                        this.coachesData = Array.isArray(res.data.list)?res.data.list:[];
                    } else {
                        this.$message.error(res.message);
                        return false;
                    }
                })
	    },
	    handleClose2() {
	      	this.dialogVisible2 = false
	    },
	    //点击选择用户行
	    handleCurrentChange2(val) {
	      	this.dialogVisible2 = false
	      	if (val) {
	        	this.ruleForm.coachId = val.id
	        	this.ruleForm.coachName = val.nickName;
	      	}
	    },
	    //当前教练页数
	    handleCurrentChangePage2(val) {
	      	this.paramcoach.pageNum = val;
	      	this.selCoachesData();
	    },
	    onSubmit(formName){
	    	if(this.ruleForm.departmentId==6){
	    	}else{
	    		this.ruleForm.coachId='';
	    		this.ruleForm.coachName='';
	    	}
	    	if(this.ruleForm.password1){
	    		this.ruleForm.password=md5(this.ruleForm.password1)
	    	}
	  		this.$refs[formName].validate((valid) => {
	          	if (valid) {            	
	          		
	            	this.$post("/authorityManagement/addManageUser", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: this.ruleForm.id?"编辑成功":"添加成功",
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	} else {
	            	console.log("error submit!!");
	            	return false;
	          	}
	    	});
	    }
  	}
}
</script>
<style scoped>
.el-input {
  	width: 80%;
}
.el-textarea__inner {
  	width: 80%;
}
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/authorityManagement/personnelList.vue